<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Carga de formularios</h1>
            </v-flex>
        </v-layout>
        <v-card>
            <v-card-title>{{ formulario.nombre }}</v-card-title>
            <v-card-text>
                <v-container>
                    <template v-for="p in formulario.preguntas">
                        <v-layout row wrap>
                            <v-flex v-if="p.pregunta_tipo_id === 1">
                                <v-radio-group :label="p.pregunta" v-model="r[p.id]" row>
                                    <v-radio label="SI" :value="true"></v-radio>
                                    <v-radio label="NO" :value="false"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex v-if="p.pregunta_tipo_id === 2">
                                <v-text-field :label="p.pregunta" v-model="r[p.id]"></v-text-field>
                            </v-flex>
                            <v-flex v-if="p.pregunta_tipo_id === 3">
                                <v-textarea :label="p.pregunta" v-model="r[p.id]"></v-textarea>
                            </v-flex>
                            <v-flex v-if="p.pregunta_tipo_id === 4">
                                <v-select :label="p.pregunta" v-model="r[p.id]" :items="p.opciones"></v-select>
                            </v-flex>
                            <v-flex v-if="p.pregunta_tipo_id === 5">
                                <v-select :label="p.pregunta" v-model="r[p.id]" :items="p.opciones" multiple></v-select>
                            </v-flex>
                        </v-layout>
                    </template>
                </v-container>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import draggable from 'vuedraggable'
    import mixinFormulario from '../../mixins/formulario/formulario';
    import mixinPregunta from '../../mixins/formulario/pregunta';
    import {mapActions} from 'vuex';

    export default {
        name: "agregar",
        mixins: [mixinFormulario, mixinPregunta],
        components: {draggable},
        data() {
            return {
                formulario: {},
                r: []
            }
        },
        mounted() {
            this.formularioShow(1, r => {
                this.formulario = r;
            }, err => {
                console.error('Error al traer formulario')
            })
        },
        methods: {
            ...mapActions('notif', ['msjShow']),

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/formulario/agregar.vue